export const SALE_PRICE_POSITIVE_ERROR =
    "El precio de venta debe ser mayor a 0";
export const SALE_PRICE_BELOW_LIMIT_ERROR =
    "El precio de venta no puede bajar más del 60% del precio de catálogo";
export const SALE_PRICE_ABOVE_CATALOG_ERROR =
    "Este pedido no viene del portal: el precio de venta no puede superar el de catálogo";

// Mismo tope de descuento del backend: el precio de venta no baja del 40% del
// precio de catálogo.
const MIN_SALE_PRICE_RATE = 0.4;

export const resolveLineSalePrice = (line) => {
    if (line.salePrice !== undefined && line.salePrice !== null) {
        return Number(line.salePrice);
    }
    return (
        Number(line.priceOffer) -
        (Number(line.appliedDiscountPerReference) || 0) +
        (Number(line.appliedSurchargePerReference) || 0)
    );
};

export const validateLineSalePrice = ({
    allowAboveCatalog = false,
    priceOffer,
    salePrice
}) => {
    if (!(salePrice > 0)) return SALE_PRICE_POSITIVE_ERROR;
    if (salePrice < priceOffer * MIN_SALE_PRICE_RATE) {
        return SALE_PRICE_BELOW_LIMIT_ERROR;
    }
    if (salePrice > priceOffer && !allowAboveCatalog) {
        return SALE_PRICE_ABOVE_CATALOG_ERROR;
    }
    return "";
};
